module.exports = __webpack_public_path__ + "img/product-ketang-zzct-06.27f0fdd2.png";